import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type EarningsInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function EarningsInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: EarningsInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M6.333 11H11v14H6.333A2.333 2.333 0 014 22.667v-9.334A2.333 2.333 0 016.333 11zM13.333 4h2.334A2.334 2.334 0 0118 6.333V25h-7V6.333A2.333 2.333 0 0113.333 4zM18 8.667h4.667A2.334 2.334 0 0125 11v11.667A2.333 2.333 0 0122.667 25H18V8.667z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default EarningsInactiveIcon;
